import { connect } from 'react-redux';
import { tradeExecutionCommentChanged } from 'state/quotes/trades/trades.action';
import { addonSelector } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export interface OwnProps {
  tabId: string;
}

export interface StateProps {
  quoteId: string;
  comment: string;
}

export interface DispatchProps {
  onCommentChanged(quoteId: string, comment: string): void;
}

export type TradeCommentProps = StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const tradeInfo = addonSelector.getTradeInfo(state, tabId);
  const quoteId = addonSelector.getLastQuoteId(state, tabId);

  return {
    quoteId: quoteId!,
    comment: tradeInfo?.comment ?? '',
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, _: OwnProps): DispatchProps => ({
  onCommentChanged(quoteId, comment) {
    dispatch(tradeExecutionCommentChanged(quoteId, comment));
  },
});

export const connectTradeComment = connect(mapStateToProps, mapDispatchToProps);
